import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import CharacterForm from './CharacterForm';
import CharacterFormService from '../services/CharacterFormService';
import { toJS } from 'mobx';
import CharacterVoiceSearchService from '../services/CharacterVoiceSearchService';

class CharacterFormContainer extends Component {
  static propTypes = {
    characterId: PropTypes.string,
  };

  static defaultProps = {
    characterId: null,
  };

  characterFormService = new CharacterFormService();
  componentWillMount() {
    this.characterFormService.handleLoad(this.props.characterId);
  }

  render() {
    return (
      <CharacterForm
        onSubmit={this.characterFormService.handleSubmit}
        onChange={this.characterFormService.form.setValue}
        onReset={this.characterFormService.form.reset}
        onVoiceSearch={CharacterVoiceSearchService.handleOpen}
        values={this.characterFormService.form.getValues()}
        errors={this.characterFormService.form.errors}
        submitting={this.characterFormService.submit.fetching}
        isDirty={this.characterFormService.form.isDirty}
        isUpdateBlocked={toJS(this.characterFormService.blockUpdate)}
        onPreviewImage={this.characterFormService.handlePreviewImage}
        onPreviewClose={this.characterFormService.handlePreviewEnd}
        isGeneratingImage={this.characterFormService.fetchPreview.fetching}
        sampleImage={toJS(this.characterFormService.sampleImage)}
      />
    );
  }
}

export default observer(CharacterFormContainer);
